import { ChevronRight, Info } from "lucide-react";

import { UploadFailedModal } from "@/components/modals/upload-failed-modal";
import { pushModal } from "@/stores/modal";
import { cn } from "@/lib/utils";
import { Button } from "@/toggle-ui-kit/button";
import { logIxdConversionGuideOpen } from "@/utils/usage-log";

/**
 * 제출용 IXD 제약 안내와 변환 CTA. 디자인이 다른 홈 STEP5 패널도 같은 것을 보여주므로
 * 문구와 CTA 동작은 여기 한 곳에서 정한다 (레이아웃만 화면마다 다르게 조립한다).
 */
export const IXD_CONVERSION_NOTICE =
  "제출용 IXD 파일은 업로드할 수 없습니다. 편집용 파일로 변환한 뒤 다시 업로드해주세요.";

export const IxdConversionGuideButton = ({
  className,
}: {
  className?: string;
}) => (
  <Button
    variant="outlined"
    color="primary"
    size={24}
    className={cn("shrink-0 border-none px-2", className)}
    rightIcon={<ChevronRight className="size-3.5" />}
    onClick={() => {
      // 홈·편집기·대사 화면 등 여러 곳에 놓이므로 어디서 눌렀는지는 경로로 남긴다
      logIxdConversionGuideOpen(window.location.pathname);
      pushModal(UploadFailedModal, { guideOnly: true });
    }}
  >
    편집용 파일 변환 방법보기
  </Button>
);

/**
 * IXD 업로드 영역 하단 상시 안내. 업로드를 시도하기 전에 제출용 파일 제약을 알린다.
 * accepts: 같은 화면에서 업로드 가능한 확장자. DSD 등을 함께 올리는 화면은 직접 넘긴다.
 * showConversionGuide: .ixd 를 아예 받지 않는 모드(공시본 zip)에서는 제출용 IXD 제약과
 *   변환 CTA 가 안내와 어긋나므로 끈다.
 */
export const IxdUploadNotice = ({
  accepts = ".ixd",
  showConversionGuide = true,
  className,
}: {
  accepts?: string;
  showConversionGuide?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "flex items-start gap-2 rounded-lg bg-background-neutral-alternative px-4 pb-4 pt-3",
        className,
      )}
    >
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-center gap-2">
          <Info className="size-4 shrink-0 text-label-normal" />
          <span className="label-2-semibold text-label-normal">안내</span>
        </div>
        <ul className="ml-6 list-disc pl-1">
          <li className="label-2-regular text-label-normal break-keep">
            {accepts} 형식의 파일만 업로드 가능합니다.
          </li>
          {showConversionGuide && (
            <li className="label-2-regular text-label-normal break-keep">
              {IXD_CONVERSION_NOTICE}
            </li>
          )}
        </ul>
      </div>

      {showConversionGuide && <IxdConversionGuideButton />}
    </div>
  );
};
